const parameters = {
  receiverEmail: 'example@example.com',
  newsletterLink: '',
  unsubscribeLink: '',
  templateID: '__PREVIEW__',
  receiver: 'receiver',
  company: 'company',
  address: 'address',
  phone: 'phone',
  url: 'url',
  certificate: 'certificate',
  logo: 'http://newsletter.mondiale.com/img/logo.jpg',
  logoSouter: 'http://newsletter.mondiale.com/img/souter-logo.png',
  engineeringServices: 'http://newsletter.mondiale.com/img/engineering_services.jpg',
  mroServices: 'http://newsletter.mondiale.com/img/mro_services.jpg',
  facebook: 'http://newsletter.mondiale.com/img/facebook.jpg',
  signature: 'http://newsletter.mondiale.com/img/signature.jpg',
  signatureCB: 'http://newsletter.mondiale.com/img/signatureCB.jpg',
  linkedIn: 'http://newsletter.mondiale.com/img/linkedIn.jpg',
  privacySouter: 'http://souter-trading.com/privacy.php',
  privacyMONDIALE: 'https://www.mondiale.com/private-policy.html',
  hideLink: true,
}

export default parameters
